export default [{
  name: 'detail',
  method: 'get',
  desc: '获取火车票订单详情',
  path: '/obt/trOrderDetail',
  params: {
    id: ''
  }
},{
  name: 'findTrRefundOrderByIds',
  method: 'get',
  desc: '根据退票订单id或原订单id获取退订单集合，二者只需要传一个，如果都穿则按退票订单id查询',
  path: '/obt/findTrRefundOrderByIds',
  params: {
    ids: '',
    orderId: '',
    changeId: '',
    queryType: ''
  }
},{
  name: 'refundDetail',
  method: 'get',
  desc: '根据订单id获取退票订单详情',
  path: '/obt/trRefundDetail',
  params: {
    id: ''
  }
},{
  name: 'findTrChangeOrderByOrderId',
  method: 'get',
  desc: '根据订单id获取改签单',
  path: '/obt/findTrChangeOrderByOrderId',
  params: {
    orderId: ''
  }
},{
  name: 'changeDetail',
  method: 'get',
  desc: '根据订单id获取改签单',
  path: '/obt/trChangeOrderDetail',
  params: {
    changeId: ''
  }
},{
  name: 'applyTrChange',
  method: 'get',
  desc: '获取可改签的乘机人',
  path: '/obt/applyTrChange',
  params: {
    orderId: ''
  }
},{
  name: 'applyTrRefund',
  method: 'get',
  desc: '获取可退乘机人',
  path: '/obt/applyTrRefund',
  params: {
    orderId: '',
    applyType: '' // 申请类型1为改签单申请,其他为正常单申请
  }
},{
  name: 'cancelOrder',
  method: 'get',
  desc: '取消火车票订单',
  path: '/obt/trOrderCancel',
  params: {
    orderId: '',
    trainAccount: '', // 12306账号
    password: '' // 12306密码
  }
},{
  name: 'trChangeOrderAdd',
  method: 'post',
  desc: '申请改签',
  path: '/obt/trChangeOrderAdd',
  params: {
    acceptNoseat: '', // 是否接受无座 0不接受 1接受
    acceptNoTotal: '',
    acceptOtherSeat: '',
    changeProveUrl: '', // 改签证明路径
    changeReasonVip: '', // 企业改签原因
    chooseSeats: '', // 选座 范围:1A-1F 2A-2F 几个人就几个(一个人时,不允许出现2A-2F)
    newFromDate: '', // 新出发日期
    newFromStationCode: '', // 新出发站三字码
    newFromTime: '', // 新出发时刻
    newSeatType: '', // 新席别
    newTicketPrice: '', // 新票价
    newToDate: '', // 新到达日期
    newToStationCode: '', // 新到达三字码
    newToTime: '', // 新到达时间
    newTrainCode: '', // 新车次
    newTrainNo: '', // 新车次内部编码
    isByidcard: '', // 是否可凭身份证进入
    orderFrom: '', // 订单来源
    orderId: '', // 订单id
    psgIds: '', // 需改签乘车人id 多个以,隔开 不能为空
    newSeatName:''//新座位名称
  }
},{
  name: 'confirmTrChangeOrder',
  method: 'get',
  desc: '确认改签',
  path: '/obt/confirmTrChangeOrder',
  params: {
    changeId: ''
  }
},{
  name: 'cancelTrChangeOrder',
  method: 'get',
  desc: '改签单取消改签',
  path: '/obt/cancelTrChangeOrder',
  params: {
    changeId: ''
  }
},{
  name: 'cancelTrRefund',
  method: 'get',
  desc: '退票单取消退票',
  path: '/obt/cancelTrRefund',
  params: {
    id: ''
  }
},{
  name: 'saveTrRefund',
  method: 'post',
  desc: '提交申请退票',
  path: '/obt/saveTrRefund',
  params: {
    orderFrom: '',
    orderId: '',
    refundReasonVip: '',
    ticketList: [
      {
        ticketId: '',
        ticketType: '', // 票类型1正常票 2改签票
      }
    ]
  }
}

]
